var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 3.3335C10.8167 3.3335 3.33334 10.8168 3.33334 20.0002C3.33334 29.1835 10.8167 36.6668 20 36.6668C29.1833 36.6668 36.6667 29.1835 36.6667 20.0002C36.6667 10.8168 29.1833 3.3335 20 3.3335ZM26.6667 21.2502H21.25V26.6668C21.25 27.3502 20.6833 27.9168 20 27.9168C19.3167 27.9168 18.75 27.3502 18.75 26.6668V21.2502H13.3333C12.65 21.2502 12.0833 20.6835 12.0833 20.0002C12.0833 19.3168 12.65 18.7502 13.3333 18.7502H18.75V13.3335C18.75 12.6502 19.3167 12.0835 20 12.0835C20.6833 12.0835 21.25 12.6502 21.25 13.3335V18.7502H26.6667C27.35 18.7502 27.9167 19.3168 27.9167 20.0002C27.9167 20.6835 27.35 21.2502 26.6667 21.2502Z",
    fill: "#07575B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus-icon.62b610b7859a47d157219c32b3689c50.svg";
export { ForwardRef as ReactComponent };